module.exports = __webpack_public_path__ + "media/toolkits/ecosystem-880d9fdc.png";